// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import packageInfo from '../../package.json'

export const environment = {
  production: false,
  analyticsKey: 'stagingAnalytics',
  progressKey: 'Progress',
  name: 'demostaging',
  appName: 'Modal',
  urlScheme: '',
  appId: 'com.modaldigital.demostaging',
  version: packageInfo.version,
  homePage: [''],
  scormEngine: 'https://api.staging.demo.modaldigital.io',
  globalScormTenantId: 'clkjr0iil0002x784lbw2mxv1',
  searchApiUrl: 'https://app.staging.demo.modaldigital.io/apis/rustici-course-search',
  searchApiBearerToken: 'WJKEnqB7kOWYRkJACffpdQXDpVmeNQ2Gyajd3W2UIZ0',
  recommendationsApiUrl: 'https://modal-recommends.reg.modaldigital.io/generate_recommendations',
  firebaseRegion: 'us-central1',
  authConfig: {
    domain: 'auth.staging.demo.modaldigital.io',
    clientId: 'O9IfJ7x8Pz89FmO2d41X1abzVEgvALxF',
    audience: 'https://app.staging.demo.modaldigital.io',
    responseType: 'token id_token'
  },
  firebaseConfig: {
    apiKey: 'AIzaSyAF4VH7s4T9q5mIZE0JIKhegydESrdjRSo',
    authDomain: 'modal-demo-staging.firebaseapp.com',
    databaseURL: 'https://modal-demo-staging-default-rtdb.firebaseio.com',
    projectId: 'modal-demo-staging',
    storageBucket: 'modal-demo-staging.appspot.com',
    messagingSenderId: '197314519029',
    appId: '1:197314519029:web:c771a8e7b28abc94cd0abc',
    measurementId: 'G-LQRW4C7552',
    vapidKey: 'BJcMNmJFzXrSnNZMvD_rBSLLBswiXK8DMD0ZLMmPaV6BJh5cZgIcfOEllEiWTHyYYgcuBZcPAv9ZPZRiSq_q1Gs',
    fallbackUrl : 'https://bocoweb.prod.bocodigital.com/ios/apps/demo-staging/v4',
    iamId: 'modal-demo-staging-state'
  },
  pspdfkit: {
    nativeLicense:
      '',
    license:
      '',
  },
  firebasePaths: {
    state: 'environment/production/iam/state/',
    space: 'environments/production/'
  },
  appLanguage: {
    general: {
      networkConnectionMessageHeader: 'Network connection is required',
      networkConnectionMessage:
        'I am sorry. To use this resource, you must be connected to the Internet.',
      connectionLost: 'Your connection to the internet was lost.',
      connectionFound: 'Your internet connection seems to have returned.',
      reloadMessage: 'Please press OK to reload.',
      showMe: 'Show Me',
      downLoading: 'Downloading',
      dismiss: 'Dismiss',
      disclaimer:
        'Confidential – For internal educational use only. Execution to content must align to role responsibilities and comply with company policies & procedures.'
    },
    topNav: {
      loggedInAs: 'Logged in as',
      since: 'since',
      availableLayouts: 'Available Layouts',
      favorites: 'Favorites',
      preferences: 'Preferences',
      logOutNow: 'Logout now',
      yes: 'Yes',
      no: 'No',
      areYouSure: 'Are you sure?',
      sorry: 'Sorry',
      okay: 'Okay',
      maybeLater: 'Maybe Later'
    },
    modals: {
      workingOffline: 'You are working offline',
      preferences: {
        profile: 'Profile',
        dataManagement: 'Data Management',
        total: 'Total',
        allStorage: 'All Storage',
        features: 'Features',
        notifications: 'Notifications',
        defaultLayout: 'Default dashboard',
        defaultLayoutMessage:
          'Select a dashboard below to change the default dashboard.',
        defaultLayoutDisclaimer:
          'the dashboard can always be changed using the drop down menu at the top right at any time.',
        close: 'Close'
      },
      updateInProgressHeader: 'Update in progress',
      updateInProgressMessage:
        'Your dashboard and resources are being updated to reflect recent changes.',
      contentUnavailableHeader: 'This content is no longer available.',
      contentUnavailableMessage:
        'This content has been disabled. Please return to the main dashboard.',
      chooseLayoutHeader: 'Would you like to make this your default dashboard?',
      chooseLayoutMessage:
        'You can change the dashboard later by clicking on the avatar in the upper right corner of the application. You can also change your default dashboard by going to preferences.',
      logout: 'Logout',
      logOutMessage: 'You will be redirected to the login screen momentarily.'
    },
    widget: {
      disabled: 'Disabled',
      waiting: 'Waiting',
      week: 'Week',
      todaysTasks: 'Todays Tasks',
      noTasks: 'Today there are no tasks.',
      youHaveNoTasks: '',
      forCurrentWeek: '',
      minutes: 'mins',
      keyObjectives: 'Key Objectives',
      todoThisWeek: 'Tasks for this week'
    },
    library: {
      noFavoritesHeader: 'No favorites',
      noFavoritesMessage: 'You have not marked any favorites.',
      folderMessage: 'inside this folder',
      pages: 'pages',
      open: 'Open',
      myFavorites: 'My Favorites'
    },
    agenda: {
      viewPdf: 'View PDF',
      time: 'Time',
      description: 'Description',
      location: 'Location'
    },
    roadmap: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      week: 'Week',
      noTasksThisDay: '',
      checkAll: 'Check all',
      unCheckAll: 'Uncheck all',
      acknowledgement: '',
      acknowledgementModalSubmit: ''
    },
    quiz: {
      quiz: 'Knowledge Check',
      begin: 'Begin',
      close: 'Close',
      submit: 'Submit',
      correct: 'Correct',
      incorrect: 'Incorrect',
      continue: 'Continue',
      sorry: 'You did not successfully achieve a passing score.',
      congratulations: 'Congratulations!'
    }
  }
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
